import StarRatings from "component/design-system/StarRatings";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import { useTranslation } from "next-i18next";
import styles from "./ProductHeaderDetail.module.scss";

interface IReviewRatingProps {
  totalReviewsCount: number;
  averageRating: number;
  size?: "small" | "large";
}
export default function ReviewRating(props: IReviewRatingProps) {
  const { totalReviewsCount, averageRating, size = "large" } = props;
  if (!totalReviewsCount) {
    return null;
  }

  const { t } = useTranslation("product");
  const isLargeSize = size === "large";

  const scrollToReviews = () => {
    const element = document.getElementById("review_product_container");

    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className={styles.star_container}>
      <StarRatings
        rating={averageRating}
        filled
        className={isLargeSize ? styles.stars : styles.stars_small}
      />
      <PAText fontSize={!isLargeSize ? FONT_SIZE[0] : FONT_SIZE[1]} bold className={styles.average_rating}>
        {averageRating.toFixed(1)}
      </PAText>

      <div className={styles.reviews_count} onClick={scrollToReviews}>
        <PAText fontSize={!isLargeSize ? FONT_SIZE[0] : FONT_SIZE[1]} color="success-secondary" underline className={styles.show_on_mobile}>
          {`(${totalReviewsCount})`}
        </PAText>
        <PAText fontSize={!isLargeSize ? FONT_SIZE[0] : FONT_SIZE[1]} color="success-secondary" underline className={styles.hide_on_mobile}>
          {`${totalReviewsCount} ${totalReviewsCount > 1 ? t("reviews") : t("review")}`}
        </PAText>
      </div>
    </div>
  );
}
